import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isWardrobeRoute } from "./contentsquare";

// Fires Meta + LinkedIn + Reddit PageView and a Contentsquare pageview on every
// SPA route change (after the first render — the bootstrap already fired
// PageView for the landing URL, and the Contentsquare tag in public/index.html
// seeded it via setPath).
// Google Ads remarketing pings happen automatically via the existing gtag
// config in public/index.html, so no per-route gtag call is needed.
export function usePageViewTracking() {
  const { pathname } = useLocation();
  const initialRef = useRef(null);

  useEffect(() => {
    if (initialRef.current === null) {
      initialRef.current = pathname;
      return;
    }
    if (pathname === initialRef.current) return;
    initialRef.current = pathname;

    const fbq = window.fbq;
    const lintrk = window.lintrk;
    const rdt = window.rdt;
    if (typeof fbq === "function") fbq("track", "PageView");
    if (typeof lintrk === "function") lintrk("track");
    if (typeof rdt === "function") rdt("track", "PageVisit");

    // Contentsquare doesn't observe React Router navigations — push each route
    // explicitly so replays and page analytics split per screen. Wardrobe
    // routes are excluded from recording entirely (see useContentsquareGate),
    // so they get no pageview either.
    if (Array.isArray(window._uxa) && !isWardrobeRoute(pathname)) {
      window._uxa.push(["trackPageview", pathname + window.location.search]);
    }
  }, [pathname]);
}
